/**资源路径*/
export enum StaticPath {
  OSS_PATH = 'https://balletme.oss-cn-shenzhen.aliyuncs.com'
}

/**静态图片*/
export enum StaticImage {
  /**客服3号微信二维码*/
  SERVICE_NUM3_WECHAT_CODE = '/h5/home/index/kf3.png',
  /**公众号二维码*/
  OFFICIAL_WECHAT_CODE = '/h5/home/index/gzh.jpg',
  /**小程序二维码*/
  MINIPROGRAM_WECHAT_CODE = '/h5/home/index/xcx.jpg',
  /**广告轮播*/
  HOME_BRANNER_1 = '/h5/home/branner/home1.jpg',
  HOME_BRANNER_2 = '/h5/home/branner/home2.jpg',
  HOME_BRANNER_3 = '/h5/home/branner/home1.jpg',
  HOME_BRANNER_4 = '/h5/home/branner/home2.jpg',
  HOME_BRANNER_5 = '/h5/home/branner/home1.jpg'

}
